var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTasks({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 23,
    viewBox: "0 0 19 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_615_3872)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8962 8.78027H12.8477V20.3757H17.8962V8.78027Z",
    fill: "#5C5D6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9782 12.0938H6.92969V20.3788H11.9782V12.0938Z",
    fill: "#5C5D6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.0583 14.8555H1.00977V20.3789H6.0583V14.8555Z",
    fill: "#5C5D6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0106 1.81507L13.633 2.60815C10.1412 10.9027 1.12891 10.1817 1.12891 10.1817C9.88179 12.0907 13.3204 7.52341 15.4774 3.82129L17.0654 4.76171L16.2589 -0.015625L12.0106 1.81507Z",
    fill: "#5C5D6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 21.1592H0V22.0808H19V21.1592Z",
    fill: "#5C5D6F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_615_3872"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 22.0811,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasks);
export default __webpack_public_path__ + "static/media/tasks.4a3b3b7307a0521fb251af1e1a960a84.svg";
export { ForwardRef as ReactComponent };